import { FC } from "react"
import { RolesSetting } from "../../../../module/settings/containers/roles/setting"

export const RolesSettingPage: FC = () => <RolesSetting />
